import $ from 'jquery';
import './headlineandcopy.scss';

$(document).ready(() => {
  $('.headline-and-copy').each((i, elem) => {
    const self = {
      elem: null,
      init (localElem) {
        self.elem = localElem;
        const events = 'click touchend';
        self.elem.find('.more-btn').on(events, self.onMoreBtnClick);
        self.elem.find('.less-btn').on(events, self.onLessBtnClick);
        self.elem.find('.share-btn').on(events, self.onShareBtnClick);
      },
      onMoreBtnClick (evt) {
        evt.preventDefault();
        self.elem.find('.more-btn-container').slideUp({
          duration: 250,
          complete () {
            self.elem.find('.more-container').slideDown({
              duration: 500,
            });
          },
        });
      },
      onLessBtnClick (evt) {
        evt.preventDefault();
        self.elem.find('.more-container').slideUp({
          duration: 500,
          complete () {
            self.elem.find('.more-btn-container').slideDown({
              duration: 250,
            });
          },
        });
      },
      onShareBtnClick (evt) {
        evt.preventDefault();
        self.elem.find('.share-layer').toggleClass('share-layer-show');
      },
    };

    const $elem = $(elem);
    self.init($elem);
  });
});



// WEBPACK FOOTER //
// ./custom_dependencies/brandhub-embxp-frontend/daimler-brandhub-modules/daimler-brandhub-design/daimler-brandhub-design-package/frontend/src/components/headlineandcopy/headlineandcopy.js